'use strict';

var bind = require('function-bind');

var $apply = require('./functionApply');
var $call = require('./functionCall');
var $reflectApply = require('./reflectApply');

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);



//////////////////
// WEBPACK FOOTER
// ./~/call-bind-apply-helpers/actualApply.js
// module id = x+9s
// module chunks = 11